var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/checkbox.scss';
import { useId } from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { SvgIconType } from '../SvgIcon/SvgIconType';
export const Checkbox = (_a) => {
    var { checked, onChange, disabled = false, id } = _a, restProps = __rest(_a, ["checked", "onChange", "disabled", "id"]);
    const checkboxId = id !== null && id !== void 0 ? id : useId();
    const isReadOnly = isNullOrUndefined(onChange);
    const styleClass = checked ? 'stroke-general fg-primary bg-primary' : 'stroke-general bg-secondary';
    const checkboxElement = (_jsxs("span", Object.assign({ className: `checkbox ${styleClass}` }, restProps, { children: [_jsx("input", { type: "checkbox", readOnly: isReadOnly, tabIndex: isReadOnly ? -1 : undefined, id: checkboxId, checked: checked, onChange: onChange, disabled: disabled }), checked ? (_jsx("span", { className: "checkbox-checked-icon-default", children: _jsx(SvgIcon, { icon: SvgIconType.Checkbox }) })) : (_jsx("span", { className: "checkbox-unchecked-icon-default" }))] })));
    return checkboxElement;
};
